module.exports = __webpack_public_path__ + "static/media/Region_20_UIL_minutes_October_17_2024.90e7493d.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/files/24-25/Region_20_UIL_minutes_October_17_2024.pdf
// module id = 247
// module chunks = 0